export default {
  en: {
    title: 'Contact Us',
    subtitle: 'Get in touch for quotation or partnership',
    heroSubtitle: 'Ready to support your agricultural needs',
    coreValuesIntro: 'Understanding our core values before contacting us',
    
    // Form
    form: {
      title: 'Send us a Message',
      name: 'Your Name',
      email: 'Email Address',
      phone: 'Phone Number',
      country: 'Country',
      product: 'Products of Interest',
      message: 'Your Message',
      submit: 'Send Message',
      
      placeholder: {
        name: 'Enter your name',
        email: 'Enter your email address',
        phone: 'Enter your phone number',
        country: 'Select your country',
        product: 'Select products you are interested in',
        message: 'Write your message here...'
      },
      
      validation: {
        required: 'This field is required',
        email: 'Please enter a valid email address'
      }
    },

    // Address
    address: {
      title: 'Our Address',
      line1: 'No. 1000 Chunshen Road,',
      line2: 'Huangdai Town, Xiangcheng District,',
      line3: 'Suzhou, Jiangsu, China'
    },

    // Contact Methods
    contactMethods: {
      email: 'Email Us',
      phone: 'Call Us',
      whatsapp: 'WhatsApp',
      wechat: 'WeChat'
    },

    // Social Media
    followUs: 'Follow Us',
    socialMedia: {
      facebook: 'Follow us on Facebook',
      twitter: 'Follow us on Twitter',
      linkedin: 'Connect on LinkedIn',
      youtube: 'Watch on YouTube',
      instagram: 'Follow on Instagram'
    },

    // FAQ Section
    faq: {
      title: 'Frequently Asked Questions',
      subtitle: 'Find answers to common questions about our products and services',
      view_faq: 'View All FAQs',
      questions: {
        q1: 'What types of tractors do you offer?',
        q2: 'Do you provide after-sales service?',
        q3: 'What is the warranty period for your products?',
        q4: 'Do you offer customization options?',
        q5: 'What are your shipping and delivery terms?'
      },
      answers: {
        a1: 'We offer a wide range of tractors including cabin tractors, front loaders, greenhouse specials, and mini tractors. Our products range from 12HP to 240HP to meet different agricultural needs.',
        a2: 'Yes, we provide comprehensive after-sales service including installation guidance, technical support, and maintenance. Our service team is available 24/7 to assist you.',
        a3: 'Our standard warranty period is 12 months or 1000 operating hours, whichever comes first. Extended warranty options are available for purchase.',
        a4: 'Yes, we offer customization options for most of our products. This includes color schemes, additional features, and specific requirements for different markets and applications.',
        a5: 'We offer worldwide shipping with flexible delivery terms. Shipping time varies by destination, typically ranging from 15-45 days. We can arrange door-to-door delivery and handle all customs procedures.'
      }
    },

    // Map Section
    map: {
      title: 'Our Locations',
      subtitle: 'Visit our headquarters or factory to learn more about our products and services',
      address: {
        office: 'Room 210, Building 1, Shahu Science and Technology Park, No.183, Tinglan Lane, Suzhou Industrial Park，P.R.China',
        factory: 'Fangcheng Sub-district, Fangzi District, High-tech Zone,Weifang City, Shandong Province，P.R.China'
      }
    },

    // Contact Information
    contactInfo: {
      title: 'Contact',
      headquarters: {
        title: 'Headquarters'
      },
      factory: {
        title: 'Production Base'
      },
      phone: {
        title: 'Phone',
        number: '+86 512 1234 5678'
      },
      email: {
        title: 'Email',
        value: 'sales@fhtim.com'
      },
      hours: {
        title: 'Business Hours',
        weekdays: 'Monday - Friday: 9:00 AM - 6:00 PM',
        saturday: 'Saturday: 9:00 AM - 1:00 PM',
        sunday: 'Sunday: Closed'
      }
    }
  },
  
  zh: {
    title: '联系我们',
    subtitle: '获取报价或合作咨询',
    heroSubtitle: '随时为您提供农业支持与服务',
    coreValuesIntro: '在联系我们之前，了解我们的核心价值观',
    
    // Form
    form: {
      title: '发送消息',
      name: '您的姓名',
      email: '电子邮箱',
      phone: '联系电话',
      country: '所在国家',
      product: '感兴趣的产品',
      message: '留言内容',
      submit: '发送消息',
      
      placeholder: {
        name: '请输入您的姓名',
        email: '请输入您的电子邮箱',
        phone: '请输入您的联系电话',
        country: '请选择您所在的国家',
        product: '请选择您感兴趣的产品',
        message: '请在此输入您的留言...'
      },
      
      validation: {
        required: '此项为必填项',
        email: '请输入有效的电子邮箱地址'
      }
    },

    // Address
    address: {
      title: '公司地址',
      line1: '江苏省苏州市相城区',
      line2: '黄埭镇春申路1000号',
      line3: '邮编：215000'
    },

    // Contact Methods
    contactMethods: {
      email: '发送邮件',
      phone: '电话咨询',
      whatsapp: 'WhatsApp咨询',
      wechat: '微信咨询'
    },

    // Social Media
    followUs: '关注我们',
    socialMedia: {
      facebook: '关注Facebook',
      twitter: '关注Twitter',
      linkedin: '关注LinkedIn',
      youtube: '关注YouTube',
      instagram: '关注Instagram'
    },

    // FAQ Section
    faq: {
      title: '常见问题',
      subtitle: '了解关于我们产品和服务的常见问题解答',
      view_faq: '查看所有常见问题',
      questions: {
        q1: '你们提供哪些类型的拖拉机？',
        q2: '是否提供售后服务？',
        q3: '产品保修期是多久？',
        q4: '是否提供定制选项？',
        q5: '发货和交付条款是什么？'
      },
      answers: {
        a1: '我们提供多种类型的拖拉机，包括驾驶室拖拉机、前装载机、温室专用型和小型拖拉机。我们的产品马力范围从12HP到240HP，可满足不同的农业需求。',
        a2: '是的，我们提供全面的售后服务，包括安装指导、技术支持和维护。我们的服务团队全天候24/7为您提供支持。',
        a3: '我们的标准保修期为12个月或1000工作小时，以先到者为准。我们还提供延长保修选项供购买。',
        a4: '是的，我们为大多数产品提供定制选项。这包括颜色方案、附加功能，以及针对不同市场和应用的特定要求。',
        a5: '我们提供全球发货服务，具有灵活的交付条款。发货时间因目的地而异，通常在15-45天之间。我们可以安排门到门送货并处理所有海关手续。'
      }
    },

    // Map Section
    map: {
      title: '我们的位置',
      subtitle: '欢迎访问我们的总部或工厂，了解更多产品和服务',
      address: {
        office: '江苏省苏州市相城区黄埭镇春申路1000号',
        factory: '山东省潍坊市坊子区坊城街道'
      }
    },

    // Contact Information
    contactInfo: {
      title: '联系方式',
      headquarters: {
        title: '公司总部'
      },
      factory: {
        title: '生产基地'
      },
      phone: {
        title: '电话',
        number: '+86 512 1234 5678'
      },
      email: {
        title: '邮箱',
        value: 'sales@fhtim.com'
      },
      hours: {
        title: '营业时间',
        weekdays: '周一至周五：上午9:00 - 下午6:00',
        saturday: '周六：上午9:00 - 下午1:00',
        sunday: '周日：休息'
      }
    }
  }
} 